import React, { useState } from "react";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

interface StarRatingProps {
  value?: number;
  onChange?: (value: number) => void;
  size?: number;
  className?: string;
  disabled?: boolean;
  showRatingDescription?: boolean
}

const StarRating: React.FC<StarRatingProps> = ({
  value = 0,
  onChange,
  size = 36,
  className = "",
  disabled = false,
  showRatingDescription = true,
}) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (star: number) => {
    if (onChange) onChange(star);
  };

  const ratingText = (rating: number) => {
    switch (rating) {
      case 1:
        return "Poor";
      case 2:
        return "Fair";
      case 3:
        return "Good";
      case 4:
        return "Very Good";
      case 5:
        return "Excellent";
      default:
        return "Select a rating";
    }
  };

  return (
    <div className={`star-rating-row ${className}`} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            onClick={() => handleClick(star)}
            onMouseEnter={() => !disabled && setHoverRating(star)}
            onMouseLeave={() => !disabled && setHoverRating(0)}
            style={{ cursor: 'pointer', marginRight: 8 }}
            aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
          >
            {(hoverRating || value) >= star ? (
              <StarIcon
                sx={{
                  color: hoverRating ? '#FFE066' : '#FFB700',
                  fontSize: size,
                  transition: 'color 0.2s'
                }}
              />
            ) : (
              <StarBorderIcon
                sx={{
                  color: '#000',
                  fontSize: size,
                  transition: 'color 0.2s',
                  borderWidth: 0.2,
                }}
              />
            )}
          </span>
        ))}
      </div>
      {showRatingDescription &&
      <div style={{ marginTop: 8, fontSize: 14, color: "#666" }}>
        {ratingText(hoverRating || value)}
      </div>}
    </div>
  );
};

export default StarRating;